import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import withRouter from "helpers/withRouter";
import BannerCustom from '../../../../components/Banners/BannerCustom'
import { activateUser, logout } from '../../../../redux/features/auth/authSlice'
import { fetchUser, fetchApp } from '../../../../redux/features/user/userSlice'
import AuthContainer from "../../AuthContainer";
import PageHelmet from "components/PageHelmet";
import { Text } from "@shopify/polaris";
import { createCustomDispatch } from "helpers/customDispatch";
import { deleteCookie } from "../../../../utils/cookie";
import { resetSessionExpiredFlag } from "../../../../helpers/callApi";
import { isLocalhost } from "../../../../utils/appIdStorage";
import { getProjectByAppId } from "../../../../projectConfig/projects";
import { getProjectSwitchUrl, getCookieDomainFromHostname } from "../../../../utils/environment";

class Activation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activationError: false,
    };
  }

  componentDidMount() {
    if (!this.props.params.code) {
      this.setState({ activationError: true });
      return;
    }

    // Reset session expired modal state so it never shows during activation
    resetSessionExpiredFlag();

    // Clear stale auth cookies with same domain so new api_key from activate response is used
    const cookieDomain = getCookieDomainFromHostname() || process.env.REACT_APP_COOKIES || undefined;
    const deleteOpts = cookieDomain ? { domain: cookieDomain } : {};
    deleteCookie("api_key", deleteOpts);
    deleteCookie("API-KEY", deleteOpts);
    deleteCookie("is_manager", deleteOpts);
    deleteCookie("api_key", { path: "/" });
    deleteCookie("API-KEY", { path: "/" });
    deleteCookie("is_manager", { path: "/" });
    if (typeof localStorage !== "undefined") {
      localStorage.removeItem("api_key");
      localStorage.removeItem("API-KEY");
      localStorage.removeItem("is_manager");
    }

    // After activation: server sends api_key + app_id; load user then redirect to project
    this.props
      .activateUser({ code: this.props.params.code })
      .then((activationPayload) => {
        const appIdFromActivation =
          activationPayload != null && activationPayload.app_id != null
            ? Number(activationPayload.app_id)
            : null;

        return Promise.all([
          appIdFromActivation != null ? Promise.resolve(appIdFromActivation) : this.props.fetchApp().then((appResult) => {
            const raw = appResult?.app_id != null ? appResult.app_id : appResult;
            return raw != null ? Number(raw) : null;
          }),
          this.props.fetchUser(),
        ]).then(([appIdResolved]) => {
          const appIdNum = appIdFromActivation ?? appIdResolved;
          if (!isLocalhost() && appIdNum != null && !isNaN(appIdNum)) {
            localStorage.setItem("app_id", String(appIdNum));
            window.dispatchEvent(new Event("appIdChanged"));
          }
          resetSessionExpiredFlag();

          const project = appIdNum != null ? getProjectByAppId(appIdNum) : null;
          const projectBaseUrl = getProjectSwitchUrl(appIdNum) ?? project?.href;
          if (projectBaseUrl) {
            const projectHome = projectBaseUrl.replace(/\/$/, "") + "/home";
            window.location.href = projectHome;
            return;
          }
          this.props.navigate("/home");
        });
      })
      .catch((error) => {
        this.setState({ activationError: true });
      });
  }

  render() {
    const { t } = this.props;

    return (
      <>
        <PageHelmet title='Activation' />
        <AuthContainer
          title={t("activation.userActivation")}
          content={
            <>
              {!this.state.activationError ? (
                <Text>{t("activation.activationInProcess")}</Text>
              ) : (
                <BannerCustom
                status={'critical'}
              message={t("activation.linkInvalid")}
            />
              )}
            </>
          }
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  apiKey: state.user.api_key,
  activationSuccessful: state.user.activationSuccessful,
  activationError: state.user.activationError,
  refererLang: state.user.refererLang,
});

const mapDispatchToProps = (defaultDispatch) => {
  const dispatch = createCustomDispatch(defaultDispatch);

  return {
    logout: () => dispatch(logout()),
    activateUser: (params) => dispatch(activateUser(params)),
    fetchUser: () => dispatch(fetchUser()),
    fetchApp: () => dispatch(fetchApp()),
  };
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(Activation))
);
